export default {
  serviceMenuOverview: "अवलोकन",
  serviceMenuPipeline: "पाइपलाइन",
  serviceMenuAnalytics: "विश्लेषण",
  serviceMenuResources: "संसाधन",
  salesServices: "बिक्री सेवाएं",
  chooseYourTypeofServicesToStreamlineAndEnhanceYourBusinessOperations:
    "अपने व्यावसायिक कार्यों को सुव्यवस्थित और बेहतर बनाने के लिए अपनी सेवाओं का प्रकार चुनें",
  dataPreparation: "डेटा तैयारी",
  salesAssistant: "बिक्री सहायक",
  appointmentSetting: "नियुक्ति सेटिंग",
  othersCustomService: "अन्य (कस्टम सेवा)",
  requestService: "सेवा का अनुरोध करें",
  learnMore: "और जानें",
  serviceRequestStatus: "सेवा अनुरोध की स्थिति",
  noServiceRequestsYet: "अभी तक कोई सेवा अनुरोध नहीं है",
  submitYourFirstRequestToUnlockThePower:
    "हमारी बिक्री सेवाओं की शक्ति को अनलॉक करने के लिए अपना पहला अनुरोध सबमिट करें! अपनी बिक्री प्रयासों को सुपरचार्ज करने के लिए यहां अपने अनुरोधों की स्थिति को ट्रैक करें। आइए शुरू करें!",
  serviceTableItemName: "नाम",
  serviceTableItemStatus: "स्थिति",
  serviceTableItemType: "प्रकार",
  serviceTableItemProgress: "प्रगति",
  serviceTableItemStart: "शुरू",
  serviceTableItemEnd: "समाप्त",
  serviceTableItemPriority: "प्राथमिकता",
  addASubject: "एक विषय जोड़ें",
  created: "बनाया गया",
  closed: "बंद",
  paused: "रोका गया",
  working: "काम कर रहा है",
  completed: "पूर्ण",
  resuming: "फिर से शुरू हो रहा है",
  reviewing: "समीक्षा कर रहा है",
  others: "अन्य",
  data_preparation: "डेटा तैयारी",
  sales_assistant: "बिक्री सहायक",
  appointment_setting: "नियुक्ति सेटिंग",
  appointment_booking: "नियुक्ति बुकिंग",
  low: "कम",
  normal: "सामान्य",
  urgent: "अत्यावश्यक",
  high: "उच्च",
  requiredCredits: "आवश्यक क्रेडिट",
  serviceCreated: "बनाया गया",
  QandARecord: "प्रश्न और उत्तर रिकॉर्ड",
  serviceAttachments: "संलग्नक",
  discussionBoard: "चर्चा बोर्ड",
  wannaAddSomething: "कुछ जोड़ना चाहते हैं?",
  serviceEdit: "संपादित करें",
  serviceDelete: "हटाएँ",
  addDescription: "विवरण जोड़ें",
  DragDropor: "खींचें और छोड़ें या",
  chooseFile: "फ़ाइल चुनें",
  toUpload: "अपलोड करने के लिए",
  ourDataPreparationService:
    "हमारी डेटा तैयारी सेवा आपके बिक्री डेटा प्रबंधन को अनुकूलित करने के लिए तैयार किए गए व्यापक समाधान प्रदान करती है। हम प्रक्रिया को सरल बनाने पर ध्यान केंद्रित करते हैं, जिससे आप अपने मौजूदा डेटासेट को बढ़ा सकते हैं, डेटा सफाई के माध्यम से सटीकता सुनिश्चित कर सकते हैं, और अपनी आवश्यकताओं के साथ पूरी तरह से संरेखित अनुकूलित सूचियां बना सकते हैं। यह दृष्टिकोण आपको अपने डेटा को प्रभावी ढंग से प्रबंधित करने के लिए आवश्यक लचीलापन और दक्षता प्रदान करता है।",
  moreoverWithOurDedicatedDataManagement:
    "इसके अलावा, हमारी समर्पित डेटा प्रबंधन सेवा, प्यूबोरियो (Pubrio) के साथ, प्रक्रिया और भी आसान हो जाती है। आप बिना किसी बाधा के फ़ाइलों को संलग्न कर सकते हैं और अतिरिक्त जानकारी के साथ अपने डेटासेट को बढ़ा सकते हैं। प्यूबोरियो (Pubrio) केवल संवर्धन से अधिक प्रदान करता है; यह आपके विशिष्ट मानदंडों के आधार पर पूरी तरह से नई सूचियां बनाने की भी अनुमति देता है। यह वैयक्तिकृत सेवा सुनिश्चित करती है कि आपके डेटासेट को आपके उद्देश्यों और उद्योग मानकों को पूरा करने के लिए सटीक रूप से तैयार किया गया है, जिससे आपको अपने डेटा परिदृश्य को नियंत्रित करने की शक्ति मिलती है।",
  flexibilityToAttach:
    "मौजूदा सूचियों को संलग्न करने या निर्दिष्ट मानदंडों के आधार पर नई सूचियां खोजने के लिए प्यूबोरियो (Pubrio) को निर्देश देने का लचीलापन।",
  comprehensiveDataEnrichment:
    "लापता विवरण जोड़ने और डेटासेट की पूर्णता को बढ़ाने के लिए व्यापक डेटा संवर्धन।",
  dataCleansingServicesToEnsureAccuracy:
    "सटीकता और गुणवत्ता सुनिश्चित करने के लिए डेटा सफाई सेवाएं, जिसमें डुप्लिकेट हटाना और त्रुटि सुधार शामिल है।",
  abilityToInstructPubrio:
    "सूक्ष्मता से परिभाषित मानदंडों के आधार पर पूरी तरह से नई सूचियों को क्यूरेट करने के लिए प्यूबोरियो (Pubrio) को निर्देश देने की क्षमता।",
  tailoringDatasetsPrecisely:
    "विशिष्ट उद्देश्यों और उद्योग मानकों के साथ संरेखित करने के लिए डेटासेट को सटीक रूप से तैयार करना।",
  dataEnrichmentWithExistingList:
    "मौजूदा सूची के साथ डेटा संवर्धन: अपनी वर्तमान सूची को प्यूबोरियो (Pubrio) पर अपलोड करके आसानी से बढ़ाएं। हम आपकी आवश्यकताओं को पूरा करने के लिए लापता विवरण, जैसे ईमेल पते और फोन नंबर, भरेंगे। उदाहरण के लिए, अपना ग्राहक डेटाबेस प्रदान करें, और हम इसे आवश्यक जानकारी के साथ अपडेट करेंगे।",
  customListGenerationIf:
    "कस्टम सूची निर्माण: यदि आपके पास कोई सूची नहीं है, तो प्यूबोरियो (Pubrio) को आपके लिए एक खोजने दें। बस हमें अपने मानदंड बताएं, जैसे नौकरी के शीर्षक या उद्योग, और हम सही सूची बनाएंगे। उदाहरण के लिए, यदि आपको किसी विशिष्ट क्षेत्र में शीर्ष प्रौद्योगिकी अधिकारियों की सूची की आवश्यकता है, तो हम इसे आपके लिए संभाल लेंगे।",
  dataCleansingForExistingLists:
    "मौजूदा सूचियों के लिए डेटा सफाई: प्यूबोरियो (Pubrio) की डेटा सफाई सेवा के साथ सुनिश्चित करें कि आपका डेटा सटीक और विश्वसनीय है। हमें अपनी सूची भेजें, और हम डुप्लिकेट हटा देंगे और किसी भी त्रुटि को ठीक कर देंगे। उदाहरण के लिए, यदि आपके पास हाल ही के लीड की सूची है, तो हम सुनिश्चित करेंगे कि यह आपके मार्केटिंग अभियानों के लिए तैयार है।",
  empoweringYourSalesEeavors:
    "आपकी बिक्री प्रयासों को सशक्त बनाते हुए, हमारी बिक्री सहायक सेवा विभिन्न महत्वपूर्ण क्षेत्रों में व्यापक सहायता प्रदान करती है, यह सुनिश्चित करते हुए कि आपकी आउटरीच और संचार रणनीतियाँ सफलता के लिए अच्छी तरह से तैयार हैं। चाहे आप आकर्षक सामग्री बनाना, घटनाओं को सहजता से व्यवस्थित करना, अनुरूप प्रस्तुतियाँ विकसित करना, या अपनी बिक्री और संचार रणनीतियों को परिष्कृत करना चाहते हों, हमारी समर्पित टीम आपकी बिक्री प्रयासों को सुपरचार्ज करने और बाजार में आपके ब्रांड की उपस्थिति को बढ़ाने के लिए यहां है।",
  craftingCompellingContent:
    "आकर्षक सामग्री बनाना: आपके दर्शकों का ध्यान आकर्षित करने के लिए प्रभावी संचार महत्वपूर्ण है। हमारी टीम आपके ब्रांड और दर्शकों की प्राथमिकताओं के अनुरूप आकर्षक सामग्री बनाने में उत्कृष्ट है। विचारोत्तेजक लिंक्डइन पोस्ट से लेकर सूचनात्मक ब्लॉग लेखों और आकर्षक सोशल मीडिया अपडेट तक, हम सुनिश्चित करते हैं कि आपका संदेश आपके लक्षित बाजार के साथ प्रतिध्वनित हो।",
  seamlessEventAndWebinarPreparation:
    "सहज घटना और वेबिनार तैयारी: घटनाएं और वेबिनार आपके दर्शकों के साथ जुड़ने और लीड उत्पन्न करने के लिए शक्तिशाली उपकरण हैं। हमारी बिक्री सहायक सेवा योजना और प्रचार से लेकर निष्पादन तक सभी विवरणों का ध्यान रखती है। चाहे वह सूचनात्मक वेबिनार की मेजबानी कर रहा हो या नेटवर्किंग घटनाओं का आयोजन कर रहा हो, हम सुनिश्चित करते हैं कि आपकी घटनाएं एक स्थायी छाप छोड़ दें।",
  tailoredContentDevelopmentAndPresentation:
    "अनुरूप सामग्री विकास और प्रस्तुति: आकर्षक प्रस्तुतियों और व्यक्तिगत संदेश के साथ अपने दर्शकों को मोहित करें। हमारी टीम विशिष्ट दर्शकों के खंडों के साथ प्रतिध्वनित होने वाले दृश्यात्मक रूप से आकर्षक डेक बनाने और अनुरूप संदेश बनाने में माहिर है। चाहे आप निवेशकों को पिच कर रहे हों या लीड को पोषित कर रहे हों, हम सुनिश्चित करते हैं कि आपकी सामग्री बाहर खड़ी हो।",
  strategicSalesAndCommunicationFrameworks:
    "रणनीतिक बिक्री और संचार ढांचे: रणनीतिक मार्गदर्शन और प्रभावी संचार स्क्रिप्ट के साथ अपनी बिक्री प्रक्रियाओं को सुव्यवस्थित करें। हमारी बिक्री सहायक सेवा आपकी टीम को रूपांतरणों को चलाने और सार्थक कनेक्शन को बढ़ावा देने के लिए आवश्यक उपकरण और रणनीतियों से लैस करती है।",
  craftingCompellingContent: "आकर्षक सामग्री बनाना",
  companyLinkedInPosts: "कंपनी लिंक्डइन पोस्ट (आवृत्ति: साप्ताहिक या मासिक)",
  personalLinkedInPosts:
    "व्यक्तिगत लिंक्डइन पोस्ट (आवृत्ति: लचीली, वरीयता और सामग्री की उपलब्धता के आधार पर)",
  websiteBlogPosts:
    "वेबसाइट ब्लॉग पोस्ट (आवृत्ति: आमतौर पर साप्ताहिक या द्विसाप्ताहिक)",
  socialMediaPosts:
    "सोशल मीडिया पोस्ट (आवृत्ति: दैनिक या प्रति सामग्री रणनीति के अनुसार)",
  emailMarketingCampaigns:
    "ईमेल मार्केटिंग अभियान (आवृत्ति: साप्ताहिक या द्विसाप्ताहिक)",
  seamlessEventAndWebinarPreparation: "सहज घटना और वेबिनार तैयारी",
  webinarAndWorkshopPreparation: "वेबिनार और कार्यशाला तैयारी",
  networkingAndOfflineEvent: "नेटवर्किंग और ऑफ़लाइन घटना समन्वय",
  tailoredContentDevelopment: "अनुरूप सामग्री विकास और प्रस्तुति",
  companyDeckPreparation:
    "कंपनी डेक तैयारी (प्रस्तुतियों, पिचों आदि के लिए)",
  highlyPersonalizedMessage:
    "अत्यधिक वैयक्तिकृत संदेश निर्माण (विशिष्ट दर्शकों के खंडों के लिए अनुरूप)",
  strategicSales: "रणनीतिक बिक्री और संचार ढांचे",
  salesCallScripts: "बिक्री कॉल स्क्रिप्ट",
  emailOutreachTemplate: "ईमेल आउटरीच टेम्पलेट",
  salesChannelStrategies: "बिक्री चैनल रणनीतियाँ",
  ourAppointmentSettingService:
    "हमारी नियुक्ति सेटिंग सेवा महत्वपूर्ण कनेक्शनों की सुविधा, उद्योग के जोखिम को बढ़ावा देने और मूल्यवान संभावित ग्राहकों को पोषित करके आपके व्यवसाय को बढ़ाने के लिए तैयार की गई है। हम व्यक्तिगत उद्योग जोखिम, सहज संगोष्ठी और वेबिनार समन्वय, नए संभावित ग्राहकों को गर्म करने, और नए दर्शकों के लिए आकर्षक दृष्टिकोण शुरू करने में विशेषज्ञ हैं।",
  individualIndustryAppointment:
    "व्यक्तिगत उद्योग नियुक्ति जोखिम और प्रतिक्रिया",
  tailoredOutreach:
    "आपके उद्योग के भीतर प्रमुख निर्णय निर्माताओं और प्रभावशाली लोगों के लिए अनुरूप आउटरीच लक्षित जोखिम सुनिश्चित करता है।",
  strategicFollowups:
    "रणनीतिक अनुवर्ती कार्रवाई हमें प्रतिक्रियाओं को मापने, चिंताओं को दूर करने और गहरे जुड़ाव को बढ़ावा देने की अनुमति देती है।",
  eachInteraction:
    "प्रत्येक बातचीत को प्राप्तकर्ता की प्रोफ़ाइल और वरीयताओं के आधार पर वैयक्तिकृत किया जाता है, जिससे प्रभाव को अधिकतम किया जाता है।",
  seminarWebinarCoordination: "सेमिनार और वेबिनार समन्वय",
  ourExpertTeamHandles:
    "हमारी विशेषज्ञ टीम प्रारंभिक योजना से लेकर घटना के बाद के अनुवर्ती कार्रवाई तक सेमिनार और वेबिनार समन्वय के हर पहलू को संभालती है।",
  weMeticulouslyPlan:
    "हम आपकी विशेषज्ञता को प्रदर्शित करने के लिए घटनाओं को सावधानीपूर्वक योजना और निष्पादित करते हैं, जिससे प्रतिभागियों के लिए एक सहज और आकर्षक अनुभव सुनिश्चित होता है।",
  byLeveragingAdvancedTechnologyPlatforms:
    "उन्नत प्रौद्योगिकी प्लेटफार्मों का लाभ उठाकर, हम बातचीत और भागीदारी को बढ़ाते हैं, जिससे आपकी घटनाओं के प्रभाव को अधिकतम किया जाता है।",
  newProspectWarmUp: "नए संभावित ग्राहक वार्म-अप",
  proactiveEngagementStrategies:
    "नए संभावित ग्राहकों को गर्म करने के लिए सक्रिय जुड़ाव रणनीतियों को नियोजित किया जाता है, जिससे उपयोगी चर्चाओं के लिए आधार तैयार होता है।",
  tailoredCommunicationStrategies:
    "आपके प्रस्तावों में तालमेल, विश्वास और रुचि बनाने के लिए अनुरूप संचार रणनीतियों को तैनात किया जाता है।",
  throughStrategicNurturing:
    "रणनीतिक पोषण के माध्यम से, हम संभावित ग्राहकों को संलग्न रखते हैं और रूपांतरण के लिए तैयार करते हैं, जिससे सफल नियुक्तियों की संभावना बढ़ जाती है।",
  newAudienceApproach: "नए दर्शकों का दृष्टिकोण",
  weEmployInnovativeStrategies:
    "हम नए दर्शकों तक पहुंचने और पारंपरिक चैनलों से परे आपके व्यवसाय की पहुंच का विस्तार करने के लिए अभिनव रणनीतियों को नियोजित करते हैं।",
  targetedOutreachCampaigns:
    "लक्षित आउटरीच अभियानों को पूरी तरह से दर्शकों के अनुसंधान और विभाजन के आधार पर तैयार किया जाता है, जिससे प्रासंगिकता और प्रभावशीलता सुनिश्चित होती है।",
  ourApproachIsContinuouslyOptimized:
    "हमारा दृष्टिकोण फीडबैक और अंतर्दृष्टि के आधार पर लगातार अनुकूलित होता है, यह सुनिश्चित करते हुए कि हम नए दर्शकों तक पहुंचने और संलग्न करने में सबसे आगे रहें।",
  individualIndustry: "व्यक्तिगत उद्योग नियुक्ति जोखिम और प्रतिक्रिया",
  personalizedAppointmentSetting:
    "उद्योग के हितधारकों के साथ वैयक्तिकृत नियुक्ति सेटिंग।",
  strategicFollowupCommunication:
    "आगे के जुड़ाव के लिए रणनीतिक अनुवर्ती संचार।",
  comprehensivePlanning: "घटनाओं की व्यापक योजना और निष्पादन।",
  utilizationOfAdvancedTechnologies:
    "उन्नत बातचीत के लिए उन्नत प्रौद्योगिकियों का उपयोग।",
  newProspectWarmUp: "नए संभावित ग्राहक वार्म-अप",
  proactiveEngagementStrategy:
    "संभावित ग्राहकों के लिए अनुरूप सक्रिय जुड़ाव रणनीति।",
  customizedCommunication: "रुचि बनाए रखने के लिए अनुकूलित संचार।",
  newAudienceApproach: "नए दर्शकों का दृष्टिकोण",
  innovativeOutreach:
    "नए दर्शकों के लिए डिज़ाइन किए गए अभिनव आउटरीच अभियान।",
  continuousRefinement: "फीडबैक और अंतर्दृष्टि के आधार पर निरंतर शोधन।",
  customService: "कस्टम सेवा",
  tailoredToMeet:
    "आपकी अनूठी जरूरतों को पूरा करने के लिए तैयार, हमारी कस्टम सेवा की पेशकश व्यापक आवश्यकताओं को संबोधित करने के लिए लचीलापन और अनुकूलनशीलता प्रदान करती है। चाहे आप वेबिनार प्रतिभागी ट्रैकिंग, ऑफ़लाइन घटना प्रचार, विज्ञापनों में वृद्धि, या किसी अन्य विशेष कार्य में सहायता की तलाश कर रहे हों, हमारी समर्पित टीम आपके लक्ष्यों को कुशलतापूर्वक और प्रभावी ढंग से प्राप्त करने में आपकी मदद करने के लिए यहां है।",
  webinarParticipantsTracking: "वेबिनार प्रतिभागी ट्रैकिंग",
  comprehensiveTrackingOfWebinar:
    "जुड़ाव के स्तर का विश्लेषण करने और मूल्यवान अंतर्दृष्टि इकट्ठा करने के लिए वेबिनार प्रतिभागियों का व्यापक ट्रैकिंग।",
  customizedReportsAndAnalytics:
    "आपके वेबिनार की प्रभावशीलता का आकलन करने और भविष्य की रणनीतियों को अनुकूलित करने के लिए अनुकूलित रिपोर्ट और विश्लेषण।",
  seamlessIntegration:
    "सुव्यवस्थित डेटा प्रबंधन और रिपोर्टिंग के लिए आपके मौजूदा सिस्टम के साथ सहज एकीकरण।",
  offlineEventPromotion: "ऑफ़लाइन घटना प्रचार",
  strategicPlanning:
    "उपस्थिति और जुड़ाव को अधिकतम करने के लिए ऑफ़लाइन घटना प्रचार अभियानों की रणनीतिक योजना और निष्पादन।",
  utilizationOfTargetedMarketingChannels:
    "अपने वांछित दर्शकों तक प्रभावी ढंग से पहुंचने के लिए लक्षित विपणन चैनलों और प्रचार रणनीतियों का उपयोग।",
  creativeApproaches:
    "प्रत्येक घटना की अनूठी विशेषताओं के लिए तैयार किए गए रचनात्मक दृष्टिकोण, अधिकतम प्रभाव और आरओआई सुनिश्चित करते हैं।",
  adsEnhancement: "विज्ञापनों में वृद्धि",
  optimizationOfAdCampaigns:
    "दृश्यता, जुड़ाव और रूपांतरण दरों को बढ़ाने के लिए विभिन्न प्लेटफार्मों पर विज्ञापन अभियानों का अनुकूलन।",
  ABTesting:
    "सबसे प्रभावी विज्ञापन क्रिएटिव, संदेश और लक्षित रणनीतियों की पहचान करने के लिए ए/बी परीक्षण और प्रदर्शन विश्लेषण।",
  continuousMonitoring:
    "बदलते बाजार की गतिशीलता के अनुकूल होने और परिणामों को अधिकतम करने के लिए विज्ञापन अभियानों की निरंतर निगरानी और समायोजन।",
  customizedSolutions: "अनुकूलित समाधान",
  ourCustomService:
    "हमारी कस्टम सेवा की पेशकश आपके विशिष्ट आवश्यकताओं और वरीयताओं को संबोधित करने के लिए पूर्वनिर्धारित सुविधाओं से परे फैली हुई है।",
  whetherYouNeedAssistance:
    "चाहे आपको डेटा विश्लेषण, सामग्री निर्माण, रणनीतिक योजना, या आपके व्यवसाय के किसी अन्य पहलू में सहायता की आवश्यकता हो, हम आपकी आवश्यकताओं के अनुरूप अपनी सेवाओं को तैयार कर सकते हैं।",
  ourFlexibleApproach:
    "हमारा लचीला दृष्टिकोण हमें आपके साथ मिलकर काम करने की अनुमति देता है ताकि अनुकूलित समाधान विकसित किए जा सकें जो मूर्त परिणाम प्रदान करते हैं और व्यवसाय के विकास को चलाते हैं।",
  setupAndImplementation:
    "वेबिनार प्रतिभागी ट्रैकिंग सिस्टम की स्थापना और कार्यान्वयन।",
  customizedReporting:
    "वेबिनार प्रदर्शन और दर्शकों के जुड़ाव को मापने के लिए अनुकूलित रिपोर्टिंग और विश्लेषण।",
  developmentAndExecution:
    "लक्षित ऑफ़लाइन घटना प्रचार अभियानों का विकास और निष्पादन।",
  coordinationOfPromotionalActivities:
    "प्रिंट सामग्री, प्रत्यक्ष मेल, और स्थानीय विज्ञापन सहित प्रचार गतिविधियों का समन्वय।",
  evaluationAndOptimization:
    "डिजिटल प्लेटफार्मों पर विज्ञापन अभियानों का मूल्यांकन और अनुकूलन।",
  creativeDevelopment:
    "आरओआई को अधिकतम करने के लिए रचनात्मक विकास, लक्ष्यीकरण शोधन और प्रदर्शन निगरानी।",
  tailoredServices:
    "विशिष्ट जरूरतों और उद्देश्यों को संबोधित करने के लिए अनुरूप सेवाएं।",
  collaborationWithOurTeam:
    "आपके अद्वितीय आवश्यकताओं को पूरा करने वाले अनुकूलित समाधान विकसित करने के लिए हमारी टीम के साथ सहयोग।",
  serviceGetStarted: "शुरू करें",
  keyFeatures: "मुख्य विशेषताएं",
  dataEnrichment: "डेटा संवर्धन",
  dataCleansing: "डेटा सफाई",
  customListGeneration: "कस्टम सूची निर्माण",
  serviceOfferings: "सेवा की पेशकश",
  introDataPreparation:
    "हमारी डेटा तैयारी सेवा आपके बिक्री डेटा प्रबंधन को अनुकूलित करने के लिए तैयार किए गए व्यापक समाधान प्रदान करती है। हम...",
  introSalesAssitant:
    "बिक्री सहायक सेवा विशेष रूप से बिक्री प्रक्रिया के अभिन्न कार्यों पर ध्यान केंद्रित करके सामान्य प्रशासनिक सहायता से परे जाती है। यह...",
  introAppointmentSetting:
    "इस सेवा में प्रदान किए गए आधार पर ग्राहकों को उनके लक्षित दर्शकों के साथ जोड़ने के लिए एक व्यक्तिगत और व्यावहारिक दृष्टिकोण शामिल है। यह...",
  introOtherService:
    '"अन्य" सेवा, जो ग्राहकों को अपनी अनूठी जरूरतों के बारे में विवरण प्रस्तुत करके कस्टम सेवाओं का अनुरोध करने की अनुमति देती है, इसके अंतर्गत आती है...',
  questionCommonPagePriorityLevelTitle:
    "इस कार्य के लिए आपकी प्राथमिकता का स्तर क्या है?",
  questionCommonPagePriorityLevelDesc:
    "अपनी कार्य प्राथमिकता बताते हुए हमें आपकी जरूरतों को तुरंत संबोधित करने में मदद मिलती है। आप इसे सबमिशन के बाद बदल सकते हैं।",
  questionCommonPageTimelineTitle:
    "सदस्यता अवधि या समय-सीमा के बारे में सोच रहे हैं?",
  questionCommonPageTimelineDesc:
    "हमें अपना पसंदीदा समय-सीमा बताएं और आप कब शुरू करने की योजना बना रहे हैं।",
  questionCommonPageServiceRequestTitle:
    "शुरू करने के लिए तैयार हैं? सबसे पहले, अपने एप्लिकेशन को एक विशिष्ट नाम दें",
  questionCommonPageServiceRequestDesc:
    "हम आपके डैशबोर्ड में प्रगति को ट्रैक करने और आपको अपडेट करने के लिए इसका उपयोग करेंगे।",
  questionCommonPageServiceDurationTitle:
    "आपकी सेवा अवधि कितने समय तक चलेगी?",
  quesitonCommonPageInvestmentBudget:
    "क्या व्यापार विकास और परियोजनाओं के लिए आपका निवेश बजट प्रति माह HKD 12000 से अधिक है?",
  questionCommonPageHearAboutUs: "आपने हमारे बारे में कहाँ सुना?",
  questionCommonPageUploadTitle:
    "कृपया डेटा संवर्धन या डेटा सफाई के लिए अपनी एक्सेल/सीएसवी फ़ाइल यहां अपलोड करें",
  questionCommonPageUploadDesc:
    "यदि आप एक कस्टम सूची निर्माण करना चुनते हैं तो आप अपलोड किए बिना छोड़ सकते हैं या 'अगला' पर क्लिक कर सकते हैं",
  questionDataPreparationPageInterestedDataOptimizationTitle:
    "आप अपने डेटा अनुकूलन के लिए किन सेवाओं में रुचि रखते हैं?",
  questionDataPreparationPageInterestedDataOptimizationDesc:
    "डेटा संवर्धन या डेटा सफाई चुनने के लिए आपको अगले चरण में एक सीएसवी फ़ाइल संलग्न करने की आवश्यकता है",
  questionDataPreparationPageDataAttributesTitle:
    "विशिष्ट डेटा विशेषताओं को चुनें जिन्हें आप फ़ाइल में शामिल करना चाहते हैं (यदि लागू हो)",
  questionDataPreparationPageDataAttributesDesc: "एक या अधिक चुनें",
  questionDataPreparationPageNumberOfLeadsTitle:
    "आप अपने व्यवसाय के लिए कितने लीड उत्पन्न या प्राप्त करना चाहते हैं?",
  questionDataPreparationPageNumberOfLeadsDesc:
    "आपके लिए हमारी सेवाओं को अनुकूलित करने के लिए मात्रा या सीमा निर्दिष्ट करें",
  website_url: "वेबसाइट यूआरएल",
  contact_first_name: "संपर्क पहला नाम",
  contact_last_name: "संपर्क अंतिम नाम",
  contact_title: "संपर्क शीर्षक",
  contact_location: "संपर्क स्थान",
  contact_work_email: "संपर्क कार्य ईमेल",
  contact_personal_email: "संपर्क व्यक्तिगत ईमेल",
  contact_work_phone: "संपर्क कार्य फोन",
  contact_personal_phone: "संपर्क व्यक्तिगत फोन",
  company_size: "कंपनी का आकार",
  company_industry: "कंपनी का उद्योग",
  company_location: "कंपनी का स्थान",
  company_founded_year: "कंपनी की स्थापना का वर्ष",
  company_keywords: "कंपनी के कीवर्ड",
  company_ranking_in_global: "वैश्विक में कंपनी की रैंकिंग",
  company_financial_status: "कंपनी की वित्तीय स्थिति",
  company_office_address: "कंपनी का कार्यालय पता",
  website_total_visit: "वेबसाइट कुल विज़िट",
  company_funding_status: "कंपनी की फंडिंग स्थिति",
  slugServiceName: "सेवा का नाम",
  slugServiceDesc: "सेवा का विवरण",
  errEnterServiceName: "कृपया सेवा का नाम दर्ज करें",
  errEnterDescription: "कृपया सेवा का विवरण दर्ज करें",
  errSelectAService: "कृपया एक सेवा चुनें",
  errSelectSpecificDataAttributes: "कृपया विशिष्ट डेटा विशेषताएँ चुनें",
  errInputTheQuantity: "कृपया मात्रा दर्ज करें",
  errSelectPriorityLevel: "कृपया अपनी प्राथमिकता का स्तर चुनें",
  errSelectTimeline: "कृपया समय-सीमा चुनें",
  errInputContent: "कृपया सामग्री दर्ज करें",
  errInvestmentBudget: "कृपया हाँ या ना चुनें",
  errServiceDuration: "कृपया सेवा की अवधि चुनें",
  errHearAboutUs: "कृपया सामग्री चुनें",
  placeHolderEnterServiceName: "सेवा का नाम दर्ज करें",
  placeHolderEnterServiceDescription: "सेवा का विवरण दर्ज करें",
  placeHolderEnterListGeneration: "सूची निर्माण दर्ज करें",
  placeHolder150TO250: "150 - 250",
  Submit: "भेजें",
  serviceDownload: "डाउनलोड करें",
  serviceExample: "उदाहरण",
  forYourReference: "आपके संदर्भ के लिए",
  yourFileNeedsToInclude:
    "आपकी फ़ाइल में कम से कम वेबसाइट या कंपनी के नाम शामिल होने चाहिए",
  includeAll: "सभी शामिल करें",
  serviceNext: "अगला",
  serviceBack: "पीछे",
  data_enrichment: "डेटा संवर्धन",
  data_cleansing: "डेटा सफाई",
  custom_list_generation: "कस्टम सूची निर्माण",
  job_title: "नौकरी का शीर्षक",
  timeline_within_one_weeks: "एक सप्ताह के भीतर समय-सीमा",
  timeline_one_to_two_weeks: "एक से दो सप्ताह की समय-सीमा",
  timeline_two_to_four_weeks: "दो से चार सप्ताह की समय-सीमा",
  timeline_recurring: "आवर्ती समय-सीमा",
  timeline_custom_range: "कस्टम सीमा समय-सीमा",
  hear_about_us_social_media: "सोशल मीडिया",
  hear_about_us_google: "गूगल",
  hear_about_us_online_article: "ऑनलाइन लेख",
  hear_about_us_webinar: "वेबिनार",
  hear_about_us_referral: "रेफरल",
  hear_about_us_custom_input: "अन्य",
  duration_last_than_one_month: "एक महीने से कम",
  duration_one_to_three_months: "एक से तीन महीने",
  duration_over_three_months: "तीन महीने से अधिक",
  duration_decide_later: "बाद में तय करें",
  yes: "हाँ",
  no: "नहीं",
  byCancelingYouCanEnsureThatNoTasksWillBeClosed:
    "रद्द करके, आप यह सुनिश्चित करते हैं कि कोई भी कार्य बंद नहीं किया जाएगा",
  areYouSureYouWantToCloseThisTask: "क्या आप वाकई इस कार्य को बंद करना चाहते हैं?",
  onceTheTaskIsClosed:
    "एक बार कार्य बंद हो जाने पर, इसे पूर्ववत नहीं किया जा सकता है, और आप इसे फिर से शुरू नहीं कर पाएंगे",
  Close: "बंद करें",
  ourTeamIsWorkingOnThisTask: "हमारी टीम इस कार्य पर काम कर रही है",
  pleaseProviceYourReasonForThisAction:
    "कृपया इस कार्रवाई के लिए अपना कारण बताएं",
  sendRequest: "अनुरोध भेजें",
  OK: "ठीक है",
  areYouSureYouWantToDelete: "क्या आप वाकई हटाना चाहते हैं",
  proceedingWithDeletionWillResultInPermanentRemovalOfTheFile:
    "हटाने की प्रक्रिया जारी रखने से फ़ाइल स्थायी रूप से हट जाएगी।",
  byCancelYouEnsureThatNoFileWillBeDeleted:
    "रद्द करके, आप यह सुनिश्चित करते हैं कि कोई भी फ़ाइल हटाई नहीं जाएगी",
  areYouSureYouWantToDeleteThis: "क्या आप वाकई इसे हटाना चाहते हैं",
  serviceMessage: "संदेश",
  serviceFile: "फ़ाइल",
  proceedingWithDeletionWillResultInPermanentRemovalOfThisMessage:
    "हटाने की प्रक्रिया जारी रखने से यह संदेश स्थायी रूप से हट जाएगा।",
  proceedingWithDeletionWillResultInPermanentRemovalOfThisFile:
    "हटाने की प्रक्रिया जारी रखने से यह फ़ाइल स्थायी रूप से हट जाएगी।",
  youEnsureThatNoMessagesWillBeDeleted:
    "रद्द करके, आप यह सुनिश्चित करते हैं कि कोई भी संदेश हटाया नहीं जाएगा",
  youEnsureThatNoFilessWillBeDeleted:
    "रद्द करके, आप यह सुनिश्चित करते हैं कि कोई भी फ़ाइल हटाई नहीं जाएगी",
  serviceDeleteFail: "हटाना विफल",
  enterYourReason: "अपना कारण दर्ज करें",
  seriveStartDate: "शुरू होने की तारीख",
  serviceEndDate: "समाप्ति तिथि",
  yourRequestHasBeenSent: "आपका अनुरोध भेज दिया गया है",
  sendUsYourFeedback: "हमें अपनी प्रतिक्रिया भेजें",
  weAreConstantlyImproving:
    "हम लगातार सुधार कर रहे हैं! हमारे प्लेटफॉर्म के भविष्य को आकार देने के लिए अपनी प्रतिक्रिया साझा करें।",
  describeYourExperienceHere: "यहां अपने अनुभव का वर्णन करें...",
  additionallyYouCanAttachAnyScreenshots:
    "इसके अतिरिक्त, आप और विवरण प्रदान करने के लिए कोई भी स्क्रीनशॉट या फ़ाइलें संलग्न कर सकते हैं।",
  sendFeedback: "प्रतिक्रिया भेजें",
  serviceResume: "फिर से शुरू करें",
  yourRequestHasBeenResumed: "आपका अनुरोध फिर से शुरू कर दिया गया है",
  yourRequestIsCurrentlyPaused: "आपका अनुरोध वर्तमान में रोका गया है",
  serviceEdited: "संपादित",
  theFileSizeCannotExceed50M: "फ़ाइल का आकार 50M से अधिक नहीं हो सकता",
};